import { responseErrorHandling, createFormData } from "../helper/common.helper";
import axiosInstance from "./axiosInstance";
import API from "../constants/api.constant";

export const getProspectKyc = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `${API.PROSPECT_KYC_DOC_GET}${id}`
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const updateProspectKycStep = async (
  customerId: string,
  stepIndex: number,
  data: any
) => {
  try {
    // Check if any value is a File (for any step)
    const hasFile = Object.values(data).some((v) => v instanceof File);
    if (hasFile) {
      const formData = createFormData(data);
      const response = await axiosInstance.patch(
        `${API.ADD_PROSPECT_KYC_DOC}${customerId}/step/${stepIndex}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return response.data;
    } else {
      const response = await axiosInstance.patch(
        `${API.ADD_PROSPECT_KYC_DOC}${customerId}/step/${stepIndex}`,
        data
      );
      return response.data;
    }
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const openProspectKycFinancialInfoFile = async (customerId: string) => {
  try {
    const response = await axiosInstance.get(
      `${API.PROSPECT_KYC_FINANCIAL_FILE}${customerId}/financial-info-file`,
      { responseType: "blob" },
    );
    const fileUrl = URL.createObjectURL(response.data);
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  } catch (error: any) {
    responseErrorHandling(error);
  }
};
